import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const Compendio = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021" tipo="documento" />
);

export default Compendio;
